const VISIBLE_CLASS = 'overcut-toast--visible';
const VISIBLE_DURATION = 3000;
const ITEM_PLACEHOLDER = '__ITEM__';

/**
 * Bottom confirmation banner shown after an Overcut quick add.
 *
 * The quick add sheet keeps the shopper on the page rather than opening the cart
 * drawer, so this is the only feedback that the line landed in the cart. It stays
 * in the DOM permanently and is revealed with opacity/transform rather than
 * `hidden`, so the live region still announces to screen readers.
 */
class OvercutToast extends HTMLElement {
  /** @type {number} */
  #timer = 0;

  connectedCallback() {
    this.textEl = this.querySelector('[data-toast-text]');
    this.show = this.show.bind(this);
    document.addEventListener('overcut-toast:show', this.show);
  }

  disconnectedCallback() {
    document.removeEventListener('overcut-toast:show', this.show);
    clearTimeout(this.#timer);
  }

  /** @param {Event} event */
  show(event) {
    const item = /** @type {CustomEvent} */ (event).detail?.text;
    if (!item || !this.textEl) return;

    const template = this.dataset.template || ITEM_PLACEHOLDER;
    const texte = template.replace(ITEM_PLACEHOLDER, item);

    clearTimeout(this.#timer);

    // Deux ajouts rapproches : la classe est deja posee, donc aucune transition
    // ne rejoue et rien ne signale visuellement le second ajout. On la retire, on
    // force un reflow, puis on la remet pour relancer l animation. Le texte est
    // reecrit dans tous les cas : la region live l annonce meme sans transition.
    if (this.classList.contains(VISIBLE_CLASS)) {
      this.classList.remove(VISIBLE_CLASS);
      void this.offsetWidth;
    }

    this.textEl.textContent = texte;
    this.classList.add(VISIBLE_CLASS);

    this.#timer = window.setTimeout(() => this.classList.remove(VISIBLE_CLASS), VISIBLE_DURATION);
  }
}

if (!customElements.get('overcut-toast')) {
  customElements.define('overcut-toast', OvercutToast);
}
